/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSupplierOrderDto } from '../../models/create-supplier-order-dto';
import { SupplierOrder } from '../../models/supplier-order';

export interface CreateOneBaseMgmtSupplierOrderControllerSupplierOrder$Params {
  supplierId: number;
      body: CreateSupplierOrderDto
}

export function createOneBaseMgmtSupplierOrderControllerSupplierOrder(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtSupplierOrderControllerSupplierOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierOrder>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtSupplierOrderControllerSupplierOrder.PATH, 'post');
  if (params) {
    rb.path('supplierId', params.supplierId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupplierOrder>;
    })
  );
}

createOneBaseMgmtSupplierOrderControllerSupplierOrder.PATH = '/api/mgmt/supplier/{supplierId}/orders';
